import { fetcher } from "helpers/fetcher";

import { TGetStaffResidenceCardRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getEmployeeResidenceCard = async (userId: string) => {
  return await fetcher<TGetStaffResidenceCardRes, any>(
    ENDPOINT.USER.GET_EMPLOYEE_RESIDENCE_CARD,
    {
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.USER.GET_EMPLOYEE_RESIDENCE_CARD.version,
        [API_HEADER.USER_ID]: userId,
      },
    }
  );
};

export const queryGetEmployeeResidenceCard = async (userId: string) => {
  return (await getEmployeeResidenceCard(userId)).data;
};

queryGetEmployeeResidenceCard._key = (userId: string) => [
  ENDPOINT.USER.GET_EMPLOYEE_RESIDENCE_CARD.url,
  userId,
];
